<template>
	<div class="ds-map">
		<div id="centermap" :style="{ height: '100%', width: '100%' }" ref="myEchart"></div>

		<!-- 各区资产数量统计浮层 -->
		<div class="district-count-bar" v-if="equityEnterpriseCount > 0 || (districtCountList && districtCountList.length)">
			<span class="dc-label dc-label-equity">职工权益兑付: {{ equityEnterpriseCount }}家</span>
			<span class="dc-label dc-label-stock">{{ stockDistrictCountText }}</span>
		</div>

		<div class="table" v-if="IsShowAssetMsg">
			<div class="title">
				<i
					class="type-dot-title"
					:style="{ background: popupType === 'equity' ? '#ff9f43' : '#f56c6c' }"
				></i>
				{{ popupType === 'equity' ? '职工权益兑付信息' : '资产标点信息' }}
				<el-button @click="closePopup" type="text" icon="el-icon-circle-close" />
			</div>
			<!-- 职工权益兑付弹框 -->
			<div class="detail-card equity-detail-card" v-if="popupType === 'equity' && currentEquityMarker.guid">
				<div class="detail-name equity-name">{{ currentEquityMarker.payEnterprise || currentEquityMarker.displayName }}</div>
				<div class="detail-row" v-if="currentEquityMarker.receiveEnterprise">
					<span class="detail-label">收款企业</span>
					<span class="detail-val addr">{{ currentEquityMarker.receiveEnterprise }}</span>
				</div>
				<el-table
					v-if="currentEquityDetails.length"
					:data="currentEquityDetails"
					stripe
					:border="false"
					size="mini"
					style="width:100%;background-color:#071a52;margin-top:8px;"
					max-height="180"
				>
					<el-table-column type="index" width="40" label="序号" align="center" />
					<el-table-column prop="payTime" label="付款时间" width="95" align="center" />
					<el-table-column prop="payAmount" label="付款金额(元)" align="center" />
				</el-table>
				<div class="detail-card empty" v-else>暂无付款明细</div>
			</div>
			<!-- 存量资产标点弹框 -->
			<div class="detail-card" v-else-if="popupType === 'asset' && currentAsset.assetName">
				<div class="detail-name">{{ currentAsset.assetName }}</div>
				<div class="detail-row">
					<span class="detail-label">资产编码</span>
					<span class="detail-val">{{ currentAsset.assetCode || '--' }}</span>
				</div>
				<div class="detail-row">
					<span class="detail-label">资产类型</span>
					<span class="detail-val" :class="currentAsset.assetType === '房产' ? 'color-house' : 'color-land'">{{ currentAsset.assetType }}</span>
				</div>
				<div class="detail-row">
					<span class="detail-label">资产状态</span>
					<span class="detail-val" :class="getMarkStatusClass(currentAsset.status)">{{ currentAsset.status || '--' }}</span>
				</div>
				<div class="detail-row">
					<span class="detail-label">资产地址</span>
					<span class="detail-val addr">{{ currentAsset.address || '--' }}</span>
				</div>
				<div class="detail-row">
					<span class="detail-label">管理员</span>
					<span class="detail-val">{{ currentAsset.manager || '--' }}</span>
				</div>
				<div class="detail-row">
					<span class="detail-label">登记时间</span>
					<span class="detail-val">{{ currentAsset.createTime || '--' }}</span>
				</div>
			</div>
			<div class="detail-card empty" v-else>暂无标点数据</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import apis from "@/http/apis";
	const zaoZhuang = require("@/views/index/charts/zaozhuang.json")

	// 职工权益兑付：圆头水滴 + 顶部高光（区别于存量资产 pin）
	const EQUITY_MARKER_PATH =
		'path://M10,1.3 C7.5,1.3 5.4,3.4 5.4,5.8 c0,1.6 1.4,4.7 4.6,9.6 3.2-4.9 4.6-8 4.6-9.6 C14.6,3.4 12.5,1.3 10,1.3 Z M10,2.8 a1.3,1.3 0 1,0 0,2.6 a1.3,1.3 0 0,0 0-2.6 Z';

	// 存量资产标点主题色（闪烁）
	const STOCK_MARKER_COLOR = '#f56c6c';
	const STOCK_MARKER_COLOR_DIM = '#ffabab';
	const STOCK_MARKER_GLOW = 'rgba(245, 108, 108, 0.45)';
	const STOCK_MARKER_GLOW_DIM = 'rgba(245, 108, 108, 0.15)';

	export default {
		name: 'centermap',
		data() {
			return {
				myChart: null,
				IsShowAssetMsg: true,
				popupType: 'asset',
				mapMarkerAssets: [],
				currentAssetIndex: 0,
				currentAsset: {},
				currentEquityMarker: {},
				currentEquityDetails: [],
				equityEnterpriseCount: 0,
				equityPaymentDetails: [],
				equityPaymentMarkers: [],
				_assetTimer: null,
				_blinkTimer: null,
				_equityBlinkOn: true,
				_userPaused: false, // 用户手动点击标点后停止轮播
				mapData: [],
				markPoints: [],
				currentCityIndex: 0,
				cities: [],
				// 各区资产数量统计
				districtCountList: [],
				// 新增：存储当前区域的数据
				currentRegionData: {
					name: "",
					area: "",
					value: 0,
					value1: 0,
					value2: 0,
					assetTypes: ""
				},
				// 新增：区域基础数据
				regionBaseData: {
					"薛城区": {
						area: "507.00",
						assetTypes: "房产、土地、房产及土地"
					},
					"市中区": {
						area: "281.4945",
						assetTypes: "房产、土地、房产及土地"
					},
					"滕州市": {
						area: "1495.14",
						assetTypes: "房产、土地、房产及土地"
					},
					"峄城区": {
						area: "1019.4",
						assetTypes: "房产、土地、房产及土地"
					},
					"山亭区": {
						area: "32897.00",
						assetTypes: "房产、土地、房产及土地"
					},
					"台儿庄区": {
						area: "538.5",
						assetTypes: "房产、土地、房产及土地"
					}
				}
			}
		},
		computed: {
			/** 存量资产各区合并为一条：存量资产：市中区20处、薛城区2处 */
			stockDistrictCountText() {
				if (!this.districtCountList || !this.districtCountList.length) {
					return '存量资产：';
				}
				const parts = this.districtCountList.map(
					item => `${item.district}${item.assetCount}处`
				);
				return `存量资产：${parts.join('、')}`;
			},
		},
		created() {
			// this.getData()
		},
		mounted() {
			this.apidata();
			this.$bus.$on('close-map-marker', () => {
				this.closePopup();
			});
		},
		beforeDestroy() {
			if (this._assetTimer) clearInterval(this._assetTimer);
			this.stopAssetMarkerBlink();
			this.$bus.$off('close-map-marker');
		},
		methods: {
			apidata() {
				// 先初始化为空数组，保证接口失败时 init() 也能正常渲染地图
				this.name = [];
				this.value = [];
				this.value1 = [];
				this.value2 = [];
				this.markPoints = [];

				// 并行请求地图区域数据和资产标记点数据
				Promise.all([
					apis.getCountryMapData().catch(err => {
						console.warn("地图区域接口请求失败", err);
						return null;
					}),
					apis.mapMarkerAssetList().catch(err => {
						console.warn("地图标点资产列表接口请求失败", err);
						return null;
					}),
					apis.districtAssetCount().catch(err => {
						console.warn("各区资产数量接口请求失败", err);
						return null;
					}),
					apis.bankruptEmpRightsPay().catch(err => {
						console.warn("破产企业职工权益兑付接口请求失败", err);
						return null;
					})
				]).then(([mapRes, assetListRes, districtRes, equityPayRes]) => {
					// 处理区域数据
					if (mapRes && mapRes.data && mapRes.data.list) {
						this.mapData = mapRes.data.list;
						let list = mapRes.data.list;
						if (Array.isArray(list)) {
							list.forEach((element) => {
								this.name.push(element.name);
								this.value.push(element.value);
								this.value1.push(element.value1);
								this.value2.push(element.value2);
								this.cities.push(element.name);
							});
						}
					}
					// 使用 mapMarkerAssetList 同时构建标记点和轮播数据，保证完全同步
					if (assetListRes && assetListRes.data && assetListRes.data.list) {
						this.mapMarkerAssets = assetListRes.data.list;
						// 直接从 mapMarkerAssets 构建 markPoints，与轮播数据完全对应
						this.markPoints = this.mapMarkerAssets
							.filter(item => item.longitude && item.latitude)
							.map((item, index) => ({
								name: item.assetName,
								coord: [item.longitude, item.latitude],
								type: item.assetType,
								assetCode: item.assetCode,
								index: index
							}));
						if (this.mapMarkerAssets.length > 0) {
							this.currentAsset = this.mapMarkerAssets[0];
							this.popupType = 'asset';
							this.startAssetCarousel();
						}
					}
					// 处理各区资产数量统计
					if (districtRes && districtRes.data && Array.isArray(districtRes.data)) {
						this.districtCountList = districtRes.data;
					}
					this.processEquityPayData(equityPayRes);
					this.init();
					// 初始高亮第一个标点
					this.$nextTick(() => {
						this.highlightMarker(0);
						this.startAssetMarkerBlink();
					});
				});
			},
			formatEquityAmount(val) {
				const num = Number(val);
				if (!Number.isFinite(num)) return '0.00';
				return num.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
			},
			processEquityPayData(res) {
				const payload = res && res.data ? res.data : {};
				const summary = payload.summary || {};
				this.equityEnterpriseCount = summary.enterpriseCount || 0;
				this.equityPaymentDetails = payload.detailList || [];

				const receiveEnterpriseMap = {};
				(payload.enterpriseList || []).forEach((item) => {
					if (item.guid) {
						receiveEnterpriseMap[item.guid] = item.receiveEnterprise || '';
					}
				});
				(this.equityPaymentDetails || []).forEach((item) => {
					if (item.parentGuid && !receiveEnterpriseMap[item.parentGuid] && item.receiveEnterprise) {
						receiveEnterpriseMap[item.parentGuid] = item.receiveEnterprise;
					}
				});

				this.equityPaymentMarkers = (payload.markers || [])
					.filter(item => item.longitude != null && item.latitude != null)
					.map(item => {
						const receiveEnterprise = receiveEnterpriseMap[item.guid] || '';
						const payEnterprise = item.payEnterprise || item.name || item.locationCompanyName || '';
						return {
							guid: item.guid,
							payEnterprise,
							receiveEnterprise,
							displayName: payEnterprise,
							coord: [Number(item.longitude), Number(item.latitude)],
						};
					});
			},
			getEquityDetailsByGuid(guid) {
				return (this.equityPaymentDetails || [])
					.filter(item => item.parentGuid === guid)
					.map(item => ({
						payTime: item.payTime || '',
						payAmount: this.formatEquityAmount(item.payAmount),
					}));
			},
			init() {
				const container = this.$refs.myEchart || document.getElementById('centermap');
				let myChart = echarts.getInstanceByDom(container) || echarts.init(container);
				this.myChart = myChart;
				echarts.registerMap('zaozhuang', zaoZhuang);
				// 使用从接口获取的标记点数据
				const markPoints = this.markPoints || [];

				// 准备地图数据
				let mapSeriesData = [{
						name: "薛城区",
						value: this.value[0],
						value1: this.value1[0],
						value2: this.value2[0],
						itemStyle: {
							normal: {
								areaColor: "#7affd4",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000001'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					},
					{
						name: "市中区",
						value: this.value[1],
						value1: this.value1[1],
						value2: this.value2[1],
						itemStyle: {
							normal: {
								areaColor: "#89ccec",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000000'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					},
					{
						name: "滕州市",
						value: this.value[2],
						value1: this.value1[2],
						value2: this.value2[2],
						itemStyle: {
							normal: {
								areaColor: "#758798",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000000'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					},
					{
						name: "峄城区",
						value: this.value[3],
						value1: this.value1[3],
						value2: this.value2[3],
						itemStyle: {
							normal: {
								areaColor: "#88ccfa",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000000'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					},
					{
						name: "山亭区",
						value: this.value[4],
						value1: this.value1[4],
						value2: this.value2[4],
						itemStyle: {
							normal: {
								areaColor: "#92ec93",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000000'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					},
					{
						name: "台儿庄区",
						value: this.value[5],
						value1: this.value1[5],
						value2: this.value2[5],
						itemStyle: {
							normal: {
								areaColor: "#16b2ac",
								borderWidth: 1,
							},
							emphasis: {
								areaColor: null,
								borderColor: '#fff',
								borderWidth: 2,
							}
						},
						label: {
							normal: {
								show: true,
								textStyle: {
									fontSize: '1.4cqw',
									color: '#000000'
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '1.8cqw',
									color: '#ffffff',
									fontWeight: 'bold'
								}
							}
						},
					}
				];

				// 禁用各区划块的悬停/选中高亮，避免点击地图时闪烁
				const silentMapSeriesData = mapSeriesData.map(region => ({
					...region,
					emphasis: { disabled: true },
					itemStyle: {
						...(region.itemStyle || {}),
						emphasis: { disabled: true },
					},
					label: {
						...(region.label || {}),
						emphasis: { disabled: true },
					},
				}));

				let option = {
					series: [{
						id: 'mainMap',
						name: '',
						type: 'map',
						zoom: 1.2,
						 
						label: {
							normal: {
								show: true,
							},
						},
						data: silentMapSeriesData,
						markPoint: {
							symbol: 'pin', // 标记类型：circle, rect, roundRect, triangle, diamond, pin, arrow, none
							symbolSize: 40, // 标记大小
							label: {
								show: false,
								position: 'top',
								formatter: '{b}',
								color: '#fff',
								fontSize: 12
							},
							itemStyle: {
								color: STOCK_MARKER_COLOR,
								borderColor: '#fff',
								borderWidth: 2
							},
							emphasis: {
								label: {
									show: false,
									fontWeight: 'bold'
								}
							},
							data: this.buildMarkPointData(-1)
						},
						roam: true,
						mapType: 'zaozhuang',
						selectedMode: false,
						itemStyle: {
							normal: {
								label: {
									show: false
								},
								borderColor: 'rgba(0, 0, 0, 0.3)',
								borderWidth: 1,
							},
							emphasis: {
								disabled: true,
							},
						},
						emphasis: {
							disabled: true,
						},
						select: {
							disabled: true,
						},
					}]
				};

				myChart.setOption(option);

				window.addEventListener('resize', function() {
					myChart.resize();
				});

				// 仅监听标点点击，忽略地图区块点击
				myChart.off('click');
				myChart.on('click', (params) => {
					if (params.componentType !== 'markPoint' && params.componentSubType !== 'markPoint') return;

					// 职工权益兑付标点
					if (params.data && params.data.markerType === 'equity') {
						const equityGuid = params.data.equityGuid;
						const item = this.equityPaymentMarkers.find(e => e.guid === equityGuid);
						if (!item) return;
						this.pauseAssetCarousel();
						this.popupType = 'equity';
						this.currentEquityMarker = item;
						this.currentEquityDetails = this.getEquityDetailsByGuid(equityGuid);
						this.IsShowAssetMsg = true;
						this.highlightMarker(this.currentAssetIndex);
						return;
					}

					const clickedCode = params.data && params.data.assetCode;
					const clickedName = params.name;

					let foundIndex = -1;
					if (clickedCode) {
						foundIndex = this.mapMarkerAssets.findIndex(a => a.assetCode === clickedCode);
					}
					if (foundIndex < 0) {
						foundIndex = this.mapMarkerAssets.findIndex(a => a.assetName === clickedName);
					}

					if (foundIndex >= 0) {
						this.pauseAssetCarousel();
						this.popupType = 'asset';
						this.currentAssetIndex = foundIndex;
						this.currentAsset = this.mapMarkerAssets[foundIndex];
						this.IsShowAssetMsg = true;
						this.highlightMarker(foundIndex);
					}
				});
			},
			closePopup() {
				this.IsShowAssetMsg = false;
			},
			pauseAssetCarousel() {
				this._userPaused = true;
				if (this._assetTimer) {
					clearInterval(this._assetTimer);
					this._assetTimer = null;
				}
			},
				buildMarkPointData(activeAssetIndex) {
				const assetPoints = (this.markPoints || []).flatMap((point, idx) => {
					const isActive = activeAssetIndex >= 0 && idx === activeAssetIndex;
					const pinColor = STOCK_MARKER_COLOR;
					const pinSize = isActive ? 44 : 32;
					const base = {
						coord: point.coord,
						assetCode: point.assetCode,
						markerType: 'asset',
						label: { show: false }
					};
					return [
						{
							...base,
							name: point.name,
							symbol: 'pin',
							symbolSize: pinSize,
							z: 2,
							itemStyle: {
								color: pinColor,
								borderColor: '#ffffff',
								borderWidth: isActive ? 2 : 1,
							shadowBlur: isActive ? 16 : 10,
								shadowColor: 'rgba(245, 108, 108, 0.9)',
								shadowOffsetY: 1
							},
							emphasis: {
								scale: 1.12,
								itemStyle: {
									color: STOCK_MARKER_COLOR,
									shadowBlur: 18,
									borderWidth: 2
								}
							}
						}
					];
				});
				return [...assetPoints, ...this.buildEquityMarkPoints()];
			},
			startAssetMarkerBlink() {
				this.stopAssetMarkerBlink();
				this._equityBlinkOn = true;
				this._blinkTimer = setInterval(() => {
					this._equityBlinkOn = !this._equityBlinkOn;
					if (this.myChart) {
						this.highlightMarker(this.currentAssetIndex);
					}
				}, 950);
			},
			stopAssetMarkerBlink() {
				if (this._blinkTimer) {
					clearInterval(this._blinkTimer);
					this._blinkTimer = null;
				}
			},
			getEquityMarkerItemStyleDim() {
				return {
					color: {
						type: 'linear',
						x: 0.5, y: 0, x2: 0.5, y2: 1,
						colorStops: [
							{ offset: 0, color: 'rgba(255, 232, 184, 0.4)' },
							{ offset: 0.35, color: 'rgba(255, 179, 71, 0.4)' },
							{ offset: 1, color: 'rgba(212, 90, 10, 0.4)' }
						]
					},
					borderColor: 'rgba(255, 248, 230, 0.2)',
					borderWidth: 1,
					shadowBlur: 2,
					shadowColor: 'rgba(255, 150, 50, 0.15)',
					shadowOffsetY: 1
				};
			},
			getEquityMarkerItemStyle() {
				return {
					color: {
						type: 'linear',
						x: 0.5,
						y: 0,
						x2: 0.5,
						y2: 1,
						colorStops: [
							{ offset: 0, color: '#ffe8b8' },
							{ offset: 0.35, color: '#ffb347' },
							{ offset: 1, color: '#d45a0a' }
						]
					},
					borderColor: 'rgba(255, 248, 230, 0.95)',
					borderWidth: 1,
					shadowBlur: 8,
					shadowColor: 'rgba(255, 150, 50, 0.85)',
					shadowOffsetY: 2
				};
			},
			buildEquityMarkPoints() {
				const blink = this._equityBlinkOn;
				const pinStyle = blink ? this.getEquityMarkerItemStyle() : this.getEquityMarkerItemStyleDim();
				return (this.equityPaymentMarkers || []).flatMap(item => [
					{
						name: `equity-${item.guid}`,
						coord: item.coord,
						markerType: 'equity',
						equityGuid: item.guid,
						symbol: EQUITY_MARKER_PATH,
						symbolSize: [9, 15],
						symbolOffset: [0, -3],
						z: 2,
						itemStyle: pinStyle,
						emphasis: {
							scale: 1.2,
							itemStyle: {
								shadowBlur: 14,
								shadowColor: 'rgba(255, 180, 60, 1)',
								borderWidth: 1.5
							}
						},
						label: { show: false }
					}
				]);
			},
			getMarkStatusClass(status) {
				const map = { '待出租': 'ci-waiting', '部分出租': 'ci-partial', '已出租': 'ci-rented' };
				return map[status] || 'ci-other';
			},
			startAssetCarousel() {
				// 用户已手动点击标点，不再自动轮播
				if (this._userPaused) return;
				if (this._assetTimer) clearInterval(this._assetTimer);
				this._assetTimer = setInterval(() => {
					if (this.mapMarkerAssets.length === 0) return;
					this.currentAssetIndex = (this.currentAssetIndex + 1) % this.mapMarkerAssets.length;
					this.currentAsset = this.mapMarkerAssets[this.currentAssetIndex];
					this.popupType = 'asset';
					// 用下标 index 高亮对应标点，准确无歧义
					this.highlightMarker(this.currentAssetIndex);
				}, 3000);
			},
			highlightMarker(activeIndex) {
				if (!this.myChart) return;
				this.myChart.setOption({
					series: [{
						id: 'mainMap',
						markPoint: {
							data: this.buildMarkPointData(activeIndex)
						}
					}]
				});
			},
			// 存量资产标点统一主题色（兼容旧引用）
			getColorByValue() {
				return STOCK_MARKER_COLOR;
			},

			// 新增方法：更新当前区域数据
			updateCurrentRegionData(regionName, regionData = null) {
				// 从地图数据中查找对应的数据
				let dataIndex = -1;
				switch (regionName) {
					case "薛城区":
						dataIndex = 0;
						break;
					case "市中区":
						dataIndex = 1;
						break;
					case "滕州市":
						dataIndex = 2;
						break;
					case "峄城区":
						dataIndex = 3;
						break;
					case "山亭区":
						dataIndex = 4;
						break;
					case "台儿庄区":
						dataIndex = 5;
						break;
				}

				if (dataIndex >= 0) {
					this.currentRegionData = {
						name: regionName,
						area: this.regionBaseData[regionName]?.area || "32897.00",
						value: this.value[dataIndex] != null ? this.value[dataIndex] : 0,
						value1: this.value1[dataIndex] != null ? this.value1[dataIndex] : 0,
						value2: this.value2[dataIndex] != null ? this.value2[dataIndex] : 0,
						assetTypes: this.regionBaseData[regionName]?.assetTypes || "房产、土地、房产及土地"
					};
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	$fontsize: 13px;

	.ds-map {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 0;
	}

	#centermap {
		position: relative;
		z-index: 0;
	}

	.tag-pri {
		background-color: #ecf5ff4f;
		border-color: #59acff;
		font-size: $fontsize;
		color: #fff;
	}

	.table {
		width: 300px;
		height: auto;
		position: absolute;
		bottom: 0px;
		left: 0px;
		z-index: 100;
		border-radius: 15px;
		background-color: rgb(0, 3, 81, 0.43);
		border: 2px solid rgb(255 255 255 / 50%);
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* 详情卡片容器 */
	.detail-card {
		padding: 6px 12px 10px;
	}
	.detail-card.empty {
		text-align: center;
		color: rgba(255,255,255,0.4);
		font-size: 12px;
		padding: 20px;
	}
	/* 资产名称 */
	.detail-name {
		font-size: 14px;
		font-weight: 600;
		color: #fff;
		margin-bottom: 8px;
		line-height: 1.4;
		border-left: 3px solid #f56c6c;
		padding-left: 7px;
	}
	/* 每行详情 */
	.detail-row {
		display: flex;
		align-items: baseline;
		margin-bottom: 5px;
		font-size: 12px;
	}
	.detail-label {
		color: rgba(1, 228, 255, 0.75);
		flex-shrink: 0;
		width: 60px;
	}
	.detail-val {
		color: rgba(255, 255, 255, 0.9);
		flex: 1;
	}
	.detail-val.addr {
		word-break: break-all;
		line-height: 1.4;
	}
	/* 类型颜色 */
	.color-house { color: #00ecf8; }
	.color-land  { color: #55aa00; }
	/* 状态颜色 */
	.ci-waiting { color: #FFA500; }
	.ci-partial { color: #00ecf8; }
	.ci-rented  { color: #55aa00; }
	.ci-other   { color: rgba(255, 255, 255, 0.5); }

	/* 标题行圆点 */
	.type-dot-title {
		display: inline-block;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 6px;
		vertical-align: middle;
		flex-shrink: 0;
	}
	/* 计数徽标 */
	.asset-counter {
		font-size: 11px;
		color: rgba(1, 228, 255, 0.7);
		margin-left: 6px;
		font-weight: normal;
	}

	/* 各区资产数量统计浮层 */
	.district-count-bar {
		position: absolute;
		top: 4px;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: center;
		gap: 8px;
		pointer-events: none;
		z-index: 5;
		width: max-content;
	}

	.dc-label {
		font-size: 13px;
		color: rgba(0, 236, 248, 0.9);
		font-weight: 600;
		white-space: nowrap;
		background: rgba(0, 10, 60, 0.65);
		border: 1px solid rgba(0, 236, 248, 0.55);
		border-radius: 4px;
		padding: 2px 8px;
	}

	.dc-label-equity {
		color: rgba(255, 159, 67, 0.95);
		border-color: rgba(255, 159, 67, 0.65);
	}

	.dc-label-stock {
		color: #ffffff;
		font-weight: 600;
		background: rgba(245, 108, 108, 0.28);
		border: 1px solid #f56c6c;
		box-shadow: 0 0 10px rgba(245, 108, 108, 0.4);
	}

	.equity-name {
		border-left-color: #ff9f43;
	}

	.color-equity-amount {
		color: #ff9f43;
		font-weight: 600;
	}

	.equity-detail-card ::v-deep .el-table tr {
		color: #fff !important;
		background-color: #071a52 !important;
	}

	.equity-detail-card ::v-deep .el-table th.el-table__cell {
		color: #fff !important;
		background-color: #3c4a77 !important;
	}

	.equity-detail-card ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
		background-color: #0d2569 !important;
	}

	.equity-detail-card ::v-deep .el-table__cell {
		padding: 4px 0 !important;
		font-size: 11px;
		border-bottom: none !important;
	}

	.equity-detail-card ::v-deep .el-table::before {
		height: 0;
	}

	.title {
		margin: 10px;
		color: #ffffffd6;
		font-size: 16px;
		font-weight: 600;
	}

	::v-deep .el-icon-circle-close {
		position: absolute;
		right: 10px;
		top: 10px;
		font-size: 24px;
		color: #fff;
	}
</style>